export default __webpack_public_path__ + "static/media/under-maintenance.b2209628.svg";